// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgBellAdd = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path d="M12.6 3a7.2 7.2 0 0 0-7.2 7.2v2.199l-2.314 4.918A.9.9 0 0 0 3.9 18.6h17.4a.9.9 0 0 0 .815-1.282l-1.32-2.811a.9.9 0 0 0-1.63.764l.719 1.529H5.318l1.796-3.817A.9.9 0 0 0 7.2 12.6v-2.4a5.4 5.4 0 0 1 5.4-5.4.9.9 0 1 0 0-1.8Z" />
    <path d="M8.166 18.945a4.044 4.044 0 0 1-.054-.345h1.82c.043.209.126.476.282.737.282.47.883 1.063 2.378 1.063 1.496 0 2.097-.594 2.379-1.063a2.36 2.36 0 0 0 .281-.737h1.82a4.159 4.159 0 0 1-.559 1.663c-.617 1.03-1.816 1.937-3.92 1.937-2.105 0-3.304-.906-3.922-1.937a4.158 4.158 0 0 1-.505-1.318ZM21.51 8.638a.9.9 0 1 0 0-1.8H18.59V3.92a.9.9 0 0 0-1.8 0v2.918h-2.918a.9.9 0 0 0 0 1.8h2.918v2.919a.9.9 0 0 0 1.8 0V8.638h2.919Z" />
  </svg>
)

export default SvgBellAdd
